module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Medium.1dc96c2f.woff";